/*
 * File: UpdateStudentPermit.ts
 * Author: Austin Robinson
 * Date Created: 7/28/2023
 * Copyright (c) DrivingDoc 2023
 */

import { privateApi } from 'api';
import { AxiosError } from "axios";
import { createMutation } from "react-query-kit";

export interface UpdateStudentPermitParams {
    id: string,
    permitNum: string | null,
    permitIssued: string | null,
    permitExpiration: string | null,
    permitRestrictions?: string | null,
    permitEndorsements?: string | null
}

async function updateStudentPermit(params: UpdateStudentPermitParams | undefined): Promise<boolean> {
    if (params === undefined) {
        return false;
    }

    const { id, ...rest } = params;
    // make api call
    await privateApi.put(`${import.meta.env.VITE_API_BASE_URL}/users/students/${id}/permit`, rest, {
        headers: {
        }
    });

    // return the data object
    return true;
}

const useUpdateStudentPermit = createMutation<boolean, UpdateStudentPermitParams, AxiosError<unknown>>({
    mutationFn: async (variables: UpdateStudentPermitParams) => updateStudentPermit(variables),
});

export { updateStudentPermit, useUpdateStudentPermit };
